// src/pages/sow-draft/RegenerateSectionModal.jsx
import PropTypes from "prop-types";
import { Button, FormField, Modal } from "../../shared/ui";

export default function RegenerateSectionModal({
  open,
  onClose,
  sectionTitle,
  instructions,
  onInstructionsChange,
  onConfirm,
}) {
  return (
    <Modal
      open={open}
      title={`Regenerate: ${sectionTitle || ""}`}
      onClose={onClose}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onConfirm}>Regenerate</Button>
        </>
      }
    >
      <FormField label="Instructions" helperText="Optional -- e.g. Make it more detailed">
        <textarea
          className="shui-input"
          rows={4}
          value={instructions}
          onChange={(e) => onInstructionsChange(e.target.value)}
          placeholder="e.g., Make it more detailed…"
        />
      </FormField>
    </Modal>
  );
}

RegenerateSectionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  sectionTitle: PropTypes.string,
  instructions: PropTypes.string.isRequired,
  onInstructionsChange: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
